/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redteclab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * https://wiki.shop-apotheke.com/pages/viewpage.action?pageId=243880971 represents the selectable reason when customer attempts to buy a belgian RX by principle product
 * @export
 * @enum {string}
 */
export const RxByPrincipleSelectableReason = {
    Fever: 'FEVER',
    Pain: 'PAIN',
    Arthritis: 'ARTHRITIS',
    NasalBlockage: 'NASAL_BLOCKAGE',
    DryCough: 'DRY_COUGH',
    FeverAndHeadache: 'FEVER_AND_HEADACHE',
    ShortTermTreatmentMildPain: 'SHORT_TERM_TREATMENT_MILD_PAIN'
};
